"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DEFAULT_OPTION_LABEL", {
    enumerable: true,
    get: function() {
        return DEFAULT_OPTION_LABEL;
    }
});
const DEFAULT_OPTION_LABEL = 'Default';
